import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e4f37794"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "strongText" }, "Name:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "strongText" }, "Username:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "strongText" }, "Email:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "strongText" }, "Prosjekt id:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { class: "strongText" }, "Owner:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_aux_card = _resolveComponent("aux-card")!

  return (_ctx.props.index <= 7)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.props.value.guid)
          ? (_openBlock(), _createBlock(_component_aux_card, {
              key: 0,
              class: "card"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.props?.value?.name) + " ", 1),
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.props?.value?.username) + " ", 1),
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.props?.value?.email), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.props?.value?.taskId)
          ? (_openBlock(), _createBlock(_component_aux_card, {
              key: 1,
              class: "card"
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.props?.value?.taskId) + " ", 1),
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.props?.value?.taskOwner?.name), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}